class MapnavController {
  constructor() {
    this.name = 'mapnav';
  }
}

export default MapnavController;
